import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import getQueryParams from "utils/getQueryParams";

export const DRIVE_KEYS_PAGE_SIZE = 100;
/**
 * Query drive snapshot
 */
export default async function getDriveSnapshot(
  query: {
    skip?: number;
    limit?: number;
    directory_id?: number | string;
    list_all?: boolean;
    include_deleted?: boolean;
    include_abandoned?: boolean;
    include_only_finalized?: boolean;
  },
  storageDrive: StorageDrive,
  patient_cognito_sub: string | undefined,
): Promise<{
  total_count: number;
  skip: number;
  limit: number;
  last_modify_datetime?: string;
  files: OrchidDriveFileNotify[];
  directories: OrchidDriveDirectoryNotify[];
}> {
  const res = await fetchOrchidAPI(
    `/api/drive_data/snapshot/storage/${storageDrive}${
      storageDrive === "note-attachment" || storageDrive === "patient-chart"
        ? `/${patient_cognito_sub}`
        : ""
    }${getQueryParams(query)}`,
    {
      credentials: "include",
      mode: "cors",
      method: "GET",
    },
  );

  if (!res.ok) {
    throw new Error(
      `failed to get ${storageDrive} drive snapshot: ${getErrorDetail(
        await res.text(),
      )}`,
    );
  }

  return res.json();
}
